export default __webpack_public_path__ + "media/images/brands/xpress/backgrounds/bg-03-0aebd0231750c9325a46ce7b54a82117.jpg";